import { z } from 'zod';

export const TabelaPrecoProdutoPartialSchema = z.object({
    pro_codigo_interno: z.number(),
    pro_descricao: z.string(),
    pro_preco_minimo: z.number().nullable(),
    pro_preco_venda: z.number().nullable(),
    pro_sku: z.string().nullable(),
});

export type TabelaPrecoProdutoPartial = z.infer<typeof TabelaPrecoProdutoPartialSchema>;
